import {Page} from "./page";
import {Game} from "./game";

function onWindowLoaded()
{
    Page.unlockButtonElement.onclick = () => { Game.start(); render(); };
    Page.bathBomb1ButtonElement.onclick = () => { Game.addBomb("Red"); render(); };
    Page.bathBomb2ButtonElement.onclick = () => { Game.addBomb("Yellow"); render(); };
    Page.bathBomb3ButtonElement.onclick = () => { Game.addBomb("Blue"); render(); };
    Page.drainTubButtonElement.onclick = () => { Game.drainTub(); render(); };
    Page.fillTubButtonElement.onclick = () => { Game.fillTub(); render(); };
    Page.tubItemDivElement.onclick = () => { Game.removeTopmostTubItem(); render(); };
    render();
}

function render()
{
    if (Game._gameState.overfilledTimesCount === 0)
        Page.bodyElement.className = "bathroom";
    else
        Page.bodyElement.className = "floodedBathroom";

    if (!Game.isStarted)
    {
        Page.unlockSectionElement.classList.remove("dontDisplay");
        Page.gameSectionElement.classList.add("dontDisplay");
    }
    else
    {
        Page.gameSectionElement.classList.remove("dontDisplay");
        Page.unlockSectionElement.classList.add("dontDisplay");
    }

    Page.tubDivElement.style.backgroundColor = `#${Game.tubColorHex}`;
    (Page.tubItemDivElement.classList as any) = "";
    Page.tubItemDivElement.textContent = "";
    if (Game.isTubFilled || !Game.hasTubItems)
        Page.tubItemDivElement.classList.add("hidden");
    else
    {
        switch (Game.topmostTubItem)
        {
            case "RedBomb":
                Page.tubItemDivElement.classList.add("redBathBomb");
                break;
            case "YellowBomb":
                Page.tubItemDivElement.classList.add("yellowBathBomb");
                break;
            case "BlueBomb":
                Page.tubItemDivElement.classList.add("blueBathBomb");
                break;
            case "Surprise":
                Page.tubItemDivElement.classList.add("surprise");
                break;

        }

        Page.tubItemDivElement.classList.add("clickable");
        if (Game._gameState.tubItems.length > 1)
            Page.tubItemDivElement.textContent = `+${Game._gameState.tubItems.length - 1}`;
    }

    if (Game._gameState.secretsCollected > 0)
        Page.messageParagraphElement.textContent = `You have found a ${Game._gameState.secretsCollected} surprises.`
}

window.onload = onWindowLoaded;